import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';         // if not already imported elsewhere
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './i18n'; // Import i18n configuration 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
